var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 10.5C2 10.2239 2.22386 10 2.5 10H9.5C9.77614 10 10 10.2239 10 10.5C10 10.7761 9.77614 11 9.5 11H2.5C2.22386 11 2 10.7761 2 10.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20631 1.5859C6.98753 0.804697 8.25412 0.8047 9.03533 1.58591L9.41409 1.96466C10.1953 2.74587 10.1953 4.01247 9.41409 4.79368L5.96031 8.24741C5.82157 8.38616 5.64508 8.48103 5.45282 8.52022L3.20055 8.97927C2.49812 9.12244 1.87758 8.50192 2.02072 7.79949L2.47973 5.54717C2.51891 5.35489 2.61378 5.17839 2.75254 5.03964L6.20631 1.5859ZM8.32808 2.29316C7.93747 1.90256 7.30417 1.90255 6.91357 2.29316L6.7077 2.49902L8.50097 4.29228L8.70683 4.08642C9.09744 3.69582 9.09744 3.06252 8.70683 2.67191L8.32808 2.29316ZM4.20716 4.99953L6.00044 3.20627L7.79371 4.99953L6.00043 6.79279L4.20716 4.99953ZM3.49991 5.70678L3.45979 5.74689L3.00079 7.99921L5.25306 7.54016L5.29318 7.50004L3.49991 5.70678Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.08d7f3fb.svg";
export { ForwardRef as ReactComponent };